import React, { useEffect } from 'react'
import { useParams, useLocation, useNavigate } from "react-router-dom";
import TextareaAutosize from 'react-autosize-textarea'
import LineTitle from '@/components/LineTitle';
import message from '@/components/Message';
import useSubmitCourse from '@/hooks/submitCourse';
import AddressPicker from './AddressPicker'
import { validator } from './validator'
import icSelect from '../images/icSelect.png'
import icNotSelect from '../images/icNotSelect.png'
import { addAddress , updateUserAddress} from '@/service/address'
import { isIOS } from '@/utils'
import s from './index.module.css'

interface IAddressInfo {
  province: string,
  city: string,
  area: string,
}

type FormKey = 'name' | 'mobile' | 'address' | 'province'


const AddressEdit = ({
  type
}: {
  type: 'add' | 'edit'
}) => {
  const navigate = useNavigate();
  let params = useParams(); // {id: "1"}
  let { state } = useLocation(); // {address: {…}}

  const  { submitCourse } = useSubmitCourse();

  const [addressInfo, setAddressInfo] = React.useState<IAddressInfo>({
    province: '',
    city: '',
    area: '',
  })

  const [formValues, setFormValues] = React.useState({
    name: '',
    mobile: '',
    address: '',
    default: false,
  })


  const getAddressDetail = () => {
    const { province, city, area } = addressInfo
    if (province || city || area) {
      return `${province} ${city} ${area}`
    }
    return ''
  }

  const judgeIsUsable = (data: any) => {
    console.log('lly-log  judgeIsUsable-- data --->', data);
    const { name,
      mobile,
      address,
    } = data

    const province = getAddressDetail()

    const isUsable = name && mobile && address && province
    setIsUsable(!!isUsable)
  }

  useEffect(() => {
    if (type === 'add') return
    setAddressInfo({
      province: state.address.province,
      city: state.address.city,
      area: state.address.area,
    })
    const newFormValues = {
      ...state.address
    }
    setFormValues(newFormValues)
    judgeIsUsable(newFormValues)
  }, [params.id])


  const [isUsable, setIsUsable] = React.useState(false)
  const [isPickerShow, setIsPickerShow] = React.useState(false)

  const handleSubmit = () => {
    const {mobile} = formValues
    let mobileValidateErrMsg = ''
    if (!isUsable) return

    // 如果是国外手机号, 包含‘-’
    if (mobile.indexOf('-') > -1) {
      const [area, m] = mobile.split('-')
      mobileValidateErrMsg = validator.mobile(m, area)
    } else {
      mobileValidateErrMsg = validator.mobile(mobile, '86')
    }

    // 校验收货信息
    const addressValidateErrMsg = validator.address(addressInfo) || ''

    if (mobileValidateErrMsg || addressValidateErrMsg) {
      message.info(mobileValidateErrMsg || addressValidateErrMsg)
      return;
    }

    const formParams = {
      ...formValues,
      ...addressInfo,
      id: params.id || '',
    }

    const fn = type === 'edit' ? updateUserAddress : addAddress
    fn(formParams).then(({success}) => {
      if(success) {
        message.info('保存成功')
        submitCourse({address: formParams})
      }else {
        message.info('保存失败')
      }
    }).catch(err => {
      console.log('lly-log -- err --->', err);
    })
  }

  const changeToggle = () => {
    setFormValues(pre => ({
      ...pre,
      default: !pre.default,
    }))
  }



  const handleChange = (name: FormKey, value: string) => {
    const str = value.trim() || ''
    const newFormValues = {
      ...formValues,
      [name]: str,
    }
    setFormValues(newFormValues)
    judgeIsUsable(newFormValues)
  }

  const handleAddress = (obj: IAddressInfo) => {
    setAddressInfo(obj)
    setIsPickerShow(false)
  }

  const { province, city, area } = addressInfo
  return (
    <>
      <LineTitle title={'收货地址'} />
      <div className={`${s.container} ${isIOS && s.isIOS}`}>
        <div
          className={s.addressForm}
        >
          <div>
            <p className={s.label}>收货人</p>
            <input
              maxLength={14}
              className={s.input}
              placeholder='姓名'
              value={formValues.name}
              onChange={(e) => handleChange('name', e.target.value)}
            />
          </div>
          <div>
            <p className={s.label}>手机号</p>
            <input
              maxLength={14}
              className={s.input}
              placeholder='11位手机号码'
              value={formValues.mobile}
              onChange={(e) => handleChange('mobile', e.target.value)}
            />
          </div>
          <div>
            <p className={s.label}>收货地址:</p>
            <input
              className={s.input}
              placeholder="请填写收货地址"
              value={getAddressDetail()}
              onClick={() => setIsPickerShow(true)}
              readOnly
            />
          </div>
          <div>
            <p className={s.label}>详细地址</p>
            {/* @ts-ignore */}
            <TextareaAutosize
              maxLength={75}
              type="text"
              className={s.input}
              placeholder='请填写详细地址'
              value={formValues.address}
              onChange={(e: any) => handleChange('address', e.target.value)}
            />
          </div>
          <div className={s.defaultAddress}>
            <img
              className={s.icon}
              src={formValues.default ? icSelect : icNotSelect}
              alt={''}
              onClick={changeToggle}
            />
            设为默认地址
          </div>
        </div>
        {
          <button
            className={isUsable ? s.btn : s.disableBtn}
            onClick={handleSubmit}
          >
            保存并使用
          </button>
        }
        {
          isPickerShow ?
            <AddressPicker
              handleAddress={handleAddress}
              closePicker={() => setIsPickerShow(false)}
              province={province}
              city={city}
              area={area}
            />
            : null
        }
      </div>
    </>
  )
}


export default AddressEdit
